// posts
export const CREATE_POST = "CREATE_POST";
export const UPDATE_POST = "UPDATE_POST";
export const DELETE_POST = "DELETE_POST";
export const FETCH_ALL_POSTS = "FETCH_ALL_POSTS";
export const LIKE_POST = "LIKE_POST";

// comments
export const CREATE_COMMENT = "CREATE_COMMENT";
export const FETCH_COMMENTS = "FETCH_COMMENTS";

// auth
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";

// user
export const FETCH_USER = "FETCH_USER";
export const UPDATE_USER = "UPDATE_USER";
export const ADD_FRIEND_REQUEST = "ADD_FRIEND_REQUEST";
export const REMOVE_FRIEND_REQUEST = "REMOVE_FRIEND_REQUEST";
export const UNFRIEND = "UNFRIEND";
export const FOLLOW_USER = "FOLLOW_USER";
export const UNFOLLOW_USER = "UNFOLLOW_USER";

// Search
export const FETCH_SEARCH_USER = "FETCH_SEARCH_USER";

// Group
export const CREATE_GROUP = "CREATE_GROUP";
export const FETCH_USER_JOINED_GROUPS = "FETCH_USER_GROUPS";
export const FETCH_LIST_MEMBER_GROUP = "FETCH_LIST_MEMBER_GROUP";

// notifications
export const FETCH_USER_NOTIFICATIONS = "FETCH_USER_NOTIFICATIONS";
export const ADD_USER_NOTIFICATIONS = "ADD_USER_NOTIFICATIONS";
export const REFRESH_NOTIFICATIONS = "REFRESH_NOTIFICATIONS";
export const SET_SEEN_NOTIFICATION = "SET_SEEN_NOTIFICATION";

// hashtags
export const FETCH_ALL_HASHTAGS = "FETCH_ALL_HASHTAGS";